class CoreFeatures extends HTMLElement {
  connectedCallback() {
    this.mediaItems = this.querySelectorAll('[data-core-features-media]');
    this.carousel = this.querySelector('splide-carousel');

    if (!this.carousel || !this.mediaItems.length) return;

    this.bindMediaSync();
  }

  bindMediaSync() {
    const bind = () => {
      const instance = this.carousel.slideInstance;

      if (!instance) {
        requestAnimationFrame(bind);
        return;
      }

      const setActiveMedia = (index) => {
        this.mediaItems.forEach((item, itemIndex) => {
          item.classList.toggle('is-active', itemIndex === index);
        });
      };

      setActiveMedia(instance.index);

      instance.on('move', (index) => {
        setActiveMedia(index);
      });

      this.blockSelectHandler = (event) => {
        if (!this.contains(event.target)) return;

        const slide = event.target.closest('[data-splide-index]');
        if (!slide) return;

        const index = parseInt(slide.getAttribute('data-splide-index'), 10);
        if (!Number.isNaN(index)) {
          setActiveMedia(index);
        }
      };

      document.addEventListener('shopify:block:select', this.blockSelectHandler);
    };

    bind();
  }

  disconnectedCallback() {
    if (this.blockSelectHandler) {
      document.removeEventListener('shopify:block:select', this.blockSelectHandler);
    }
  }
}

if (!customElements.get('core-features')) {
  customElements.define('core-features', CoreFeatures);
}
